import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "badge", "label"]

  connect() {
    this.previousCount = this.selectedCount()
    this.render(this.previousCount)
  }

  recompute() {
    const nextCount = this.selectedCount()
    const changed = nextCount !== this.previousCount

    // 1️⃣ update DOM d'abord
    this.render(nextCount)

    // 2️⃣ puis animation
    if (changed) {
      this.animateCounters(nextCount > this.previousCount)
    }

    this.previousCount = nextCount
  }

  selectedCount() {
    const checkboxes = this.element.querySelectorAll(
      "input[type='checkbox'][name='subscription[fund_ids][]']"
    )
    const extraFunds = this.element.querySelectorAll(
      "input[type='hidden'][name='subscription[extra_fund_ids][]']"
    )

    let count = 0
    checkboxes.forEach((cb) => {
      if (cb.checked) count++
    })

    return count + extraFunds.length
  }

  render(count) {
    this.countTargets.forEach((el) => {
      el.textContent = count
    })

    if (this.hasLabelTarget) {
      this.labelTarget.textContent =
        count === 1 ? "fonds sélectionné" : "fonds sélectionnés"
    }

    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.toggle("hidden", count === 0)
    }
  }

  animateCounters(isIncrease) {
    this.countTargets.forEach((el) => {
      el.classList.remove("text-success-400", "text-danger-400")

      el.classList.add(
        isIncrease ? "text-success-400" : "text-danger-400"
      )

      el.classList.remove("counter-animate")
      void el.offsetWidth
      el.classList.add("counter-animate")

      window.setTimeout(() => {
        el.classList.remove("text-success-400", "text-danger-400")
      }, 400)
    })
  }
}
